import _ from 'lodash'

// variable to save the overall config object
let configurations = {}

function set(configObject) {
  configurations = configObject
}

function get(key) {
  return _.get(configurations, key)
}

export default {
  get,
  set,
}
